"use client";

import BookACallForm from "@stadium/shared/src/components/book-a-call/form";

import styles from "./main.module.scss";

const BookACallClient = (props) => {
  return <BookACallForm styles={styles} showTitle={false} {...props} />;
};

export default BookACallClient;
